import { useEffect } from "react";

const SEO = ({ title, description }) => {
  useEffect(() => {
    const nextTitle = title || "Lenvia Web App";
    const nextDescription = description || "Lenvia Web App built with React";

    document.title = nextTitle;

    let descriptionMeta = document.querySelector('meta[name="description"]');
    if (!descriptionMeta) {
      descriptionMeta = document.createElement("meta");
      descriptionMeta.setAttribute("name", "description");
      document.head.appendChild(descriptionMeta);
    }
    descriptionMeta.setAttribute("content", nextDescription);
  }, [title, description]);

  return null;
};

export default SEO;
